$bog_vmap_app_shelf $mol_page
	links? \
	pack_link \
	land_classes /$mol_tree2
	class_list /string
	dragged? \
	drag_x? 0
	drag_y? 0
	drag_source \
	drag_title \
	item_source* \
	class_offers /
	place? \
	files? /File
	classes_showed? false
	filter? \
	editable true
	title \Полка
	tools /
		<= Filter $mol_search
			hint \Поиск по деталям и классам
			query? <=> filter?
	Level $mol_check
		title \Все классы пака
		hint \Классы донорского пака целиком: примитивы, из которых верстают внутри блока
		checked? <=> classes_showed?
	Source $mol_expander
		title \Пак компонентов
		expanded? <=> source_expanded? true
		content <= source_content /
			<= Pack_list $mol_list
				rows <= pack_rows /
			<= Links_field $mol_form_field
				name \Адрес приложения
				bids / <= rejected_note \
				control <= Links $mol_string
					hint \Адрес приложения, ленды через запятую
					value? <=> links?
					enabled <= editable
			<= Import_field $mol_form_field
				name \Файлы модуля
				bids / <= import_note? \
				control <= Import_open $mol_button_open
					hint \Файлы .view.tree модуля mol. Объявления приедут, поведение — нет
					accept \.tree
					multiple true
					files? <=> files?
	pack_state_note \
	place_note? \
	Parts $mol_expander
		title \Готовые детали
		expanded? <=> parts_expanded? true
		content <= parts_content /
			<= Pack_state $mol_status
				status <= pack_state_note
			<= Place_note $mol_status
				status <= place_note?
			<= Items $mol_list
				rows <= item_rows /
	Apps $mol_form_field
		name <= apps_title \
		bids / <= app_error \
		control <= App_list $mol_list
			rows <= app_rows /
	Pack_row* $mol_button_minor
		title <= pack_title* \
		hint <= pack_hint* \
		enabled <= editable
		attr *
			^
			bog_vmap_app_shelf_pack_current <= pack_current* false
		click? <=> pack_click*? null
	Store $bog_vmap_app_publish_store
	Palette $bog_vmap_app_palette
		compact true
		pack_link <= pack_link
		land_classes <= land_classes
		query? <=> filter?
		dragged? <=> dragged?
		drag_x? <=> drag_x?
		drag_y? <=> drag_y?
	Item_row* $bog_vmap_app_palette_item
		title <= item_title* \
		hint <= item_hint* \
		lacking <= item_lacking* false
		click? <=> item_click*? null
		drag_start? <=> item_drag*? null
